import React from 'react'
import { Grid, PageSection as Section } from '@superhi/design'

import { API } from 'src/api'
import Person from 'src/components/Person'

const GRID_1_ROW_GAP = { small: 24, medium: 32, large: 40, xlarge: 40 }
const GRID_1_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 4,
}

type Props = API.TeamComponent

const Team: React.FC<React.PropsWithChildren<Props>> = ({ nodes }) => {
  const team = nodes || []

  return (
    <Section
      title="Meet the team"
      subtitle="Who makes the magic happen? We collectively live in seven countries across five time zones!"
      collapseTopPadding
      headingLevel={2}
    >
      <Grid rowGap={GRID_1_ROW_GAP}>
        {team.map((person) => (
          <Grid.Cell key={person.id} span={GRID_1_SPAN_1}>
            <Person
              {...person}
              headingLevel={3}
              location={person.location || undefined}
              imageLazy
            />
          </Grid.Cell>
        ))}
      </Grid>
    </Section>
  )
}

export default Team
